import { useContext } from 'react';
import { GameRegistryContext } from '@/contexts/GameRegistryContextTypes';

export function useGameRegistry() {
  const context = useContext(GameRegistryContext);

  if (context === undefined) {
    throw new Error('useGameRegistry must be used within a GameRegistryProvider');
  }

  return context;
}